export default class ExtensionController {
  constructor(resource) {
    this._resource = resource;
  }

  async getExtensionAvailability(id) {
    return this._resource('vehicleRequest/extend-reservation/1')
      .save({ vehicle_request_id: id })
      .then((res) => res.body)
      .catch((e) => {
        throw e;
      });
  }
  async getAdditionalExtensionValue(id, newDate, addOffer) {
    return this._resource('vehicleRequest/extend-reservation/2')
      .save({
        vehicle_request_id: id,
        new_end_date: newDate,
        offer: addOffer,
      })
      .then((res) => res.body)
      .catch((e) => {
        throw e;
      });
  }
  async ExtendReservation(id, newDate, card, addOffer, defaultPrice) {
    return this._resource('vehicleRequest/extend-reservation/3')
      .save({
        vehicle_request_id: id,
        new_end_date: newDate,
        card_id: card.id,
        offer: addOffer,
        defaultPrice,
      })
      .then((res) => res.body)
      .catch((e) => {
        throw e;
      });
  }
}
